import { createAction, createReducer } from "@reduxjs/toolkit"
import { api } from "./helpers/api"
import { LOADING_INITIAL_STATE, setFailed, setReceived, setRequested } from "modules/loader-watchers/helpers/loading"

const shortLinkUrl = (token) => `${process.env.REACT_APP_API_URL}/s/${token}`

const resolveShortLinkRequested = createAction("shortLink/resolveRequested")
const resolveShortLinkReceived = createAction("shortLink/resolveReceived")
const resolveShortLinkFailed = createAction("shortLink/resolveFailed")

const initialState = {
  ...LOADING_INITIAL_STATE
}

const shortLinkReducer = createReducer(initialState, {
  [resolveShortLinkRequested.type]: (state) => { setRequested(state) },
  [resolveShortLinkReceived.type]: (state) => { setReceived(state) },
  [resolveShortLinkFailed.type]: (state) => { setFailed(state) }
})

export default shortLinkReducer

export const resolveShortLink = (token) =>
  api({
    url: shortLinkUrl(token),
    method: "get",
    noAuth: true,
    onStart: resolveShortLinkRequested.type,
    onSuccess: resolveShortLinkReceived.type,
    onError: resolveShortLinkFailed.type,
    suppressErrorNotification: true
  })
